module.exports = __webpack_public_path__ + "static/media/popupcard_2.e3bddf42.png";